import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/code_login.png';
import _imports_1 from '@/assets/images/zhs_icon.png';
const _withScopeId = n => (_pushScopeId("data-v-780efcae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-components"
};
const _hoisted_2 = {
  key: 0,
  class: "login-form"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mima1"
}, null, -1));
const _hoisted_4 = {
  class: "btn-line"
};
const _hoisted_5 = {
  key: 1,
  class: "third-login"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "third-login-title"
}, "其他登录方式", -1));
const _hoisted_7 = {
  class: "other-login"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "third-login-logo tongyi-pic"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "third-login-link",
  underline: false
}, "统一身份登录", -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "third-login-logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "third-login-link",
  underline: false
}, "智慧树登录", -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = {
  key: 1,
  class: "login-form register-form"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "register-head"
}, "用户注册", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-gonghao"
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "organ-icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-xueyuan"
})], -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouji1"
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-yanzhengma"
}, null, -1));
const _hoisted_20 = {
  class: "code-text"
};
const _hoisted_21 = {
  key: 1,
  class: "code-get"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mima"
}, null, -1));
const _hoisted_23 = {
  class: "agree-tip"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode(" 我同意 "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.zhihuishu.com/user/protocal.html",
  target: "_blank",
  class: "link-unit"
}, " 《用户服务协议》 "), /*#__PURE__*/_createTextVNode(" 和 "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.zhihuishu.com/columnsapp/student/UserPrivacyProtocol/PrivacyPolicy1.html",
  target: "_blank",
  class: "link-unit"
}, " 《隐私政策》 ")], -1));
const _hoisted_25 = {
  class: "dialog-footer"
};
const _hoisted_26 = {
  style: {
    "margin-top": "14px"
  }
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已有账号？", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "验证码将会发送至您的绑定手机", -1));
const _hoisted_29 = {
  class: "reset-form"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouji1"
}, null, -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-yanzhengma"
}, null, -1));
const _hoisted_32 = {
  class: "code-text"
};
const _hoisted_33 = {
  key: 1,
  class: "code-get"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mima"
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mima"
}, null, -1));
const _hoisted_36 = {
  slot: "footer",
  class: "dialog-footer"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "为保证您的账号安全，请先绑定手机号后再操作", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouji1"
}, null, -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-yanzhengma"
}, null, -1));
const _hoisted_40 = {
  class: "code-text"
};
const _hoisted_41 = {
  key: 1,
  class: "code-get"
};
const _hoisted_42 = {
  slot: "footer",
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_Captcha = _resolveComponent("Captcha");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$data.showRegister ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_tabs, {
    modelValue: $data.logInType,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.logInType = $event),
    "before-leave": $options.handlerTabs
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "手机号登录",
      name: "1"
    }), _createVNode(_component_el_tab_pane, {
      label: $data.loginText,
      name: "2"
    }, null, 8, ["label"])]),
    _: 1
  }, 8, ["modelValue", "before-leave"]), $data.load ? (_openBlock(), _createBlock(_component_el_form, {
    key: 0,
    ref: "loginForm",
    model: $data.loginForm,
    rules: $data.loginRules
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "username"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        ref: "username",
        placeholder: $data.logInType === '2' ? $data.loginInputText : '请输入手机号',
        modelValue: $data.loginForm.username,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.loginForm.username = $event),
        name: "username",
        tabindex: "1",
        type: "text",
        "auto-complete": "on"
      }, {
        prefix: _withCtx(() => [_createElementVNode("i", {
          class: _normalizeClass(`iconfont ${$data.logInType === '2' ? 'icon-gonghao' : 'icon-shouji1'}`)
        }, null, 2)]),
        _: 1
      }, 8, ["placeholder", "modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "password"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        key: "password",
        ref: "password",
        modelValue: $data.loginForm.password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.loginForm.password = $event),
        type: "password",
        placeholder: "请输入您的密码",
        name: "password",
        tabindex: "2",
        "auto-complete": "on",
        onKeyup: _withKeys($options.handleLogin, ["enter"])
      }, {
        prefix: _withCtx(() => [_hoisted_3]),
        _: 1
      }, 8, ["modelValue", "onKeyup"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item-third"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: _withModifiers($options.handleLogin, ["prevent"]),
        class: "login-button",
        type: "primary",
        loading: $data.loading
      }, {
        default: _withCtx(() => [_createTextVNode(" 登 录 ")]),
        _: 1
      }, 8, ["onClick", "loading"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [$props.projectInfo.register_now ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "register-btn",
        underline: false,
        onClick: _cache[3] || (_cache[3] = (...args) => $options.openRegister && $options.openRegister(...args))
      }, " 立即注册 ")) : _createCommentVNode("", true), _createElementVNode("span", {
        style: {
          "float": "right",
          "cursor": "pointer"
        },
        underline: false,
        onClick: _cache[4] || (_cache[4] = $event => $data.showResetDialog = true)
      }, " 忘记密码 ")])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"])) : _createCommentVNode("", true), $props.projectInfo.sso_login || $props.projectInfo.zhs_login ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [$props.projectInfo.sso_login ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "login-content",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.unityLogin && $options.unityLogin(...args))
  }, _hoisted_10)) : _createCommentVNode("", true), $props.projectInfo.zhs_login ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "login-content",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.zhsLogin && $options.zhsLogin(...args))
  }, _hoisted_13)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.showRegister ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, $data.load ? (_openBlock(), _createBlock(_component_el_form, {
    key: "register",
    ref: "registerForm",
    model: $data.registerForm,
    rules: $data.registerRules,
    "auto-complete": "on"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "userName"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        placeholder: "请输入您的真实姓名",
        modelValue: $data.registerForm.userName,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.registerForm.userName = $event),
        "auto-complete": "on",
        maxlength: "11",
        size: "default"
      }, {
        prefix: _withCtx(() => [_hoisted_16]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "orgId"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_cascader, {
        modelValue: $data.registerForm.orgId,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.registerForm.orgId = $event),
        size: "small",
        options: $data.organList,
        props: $data.organProps,
        clearable: "",
        filterable: "",
        placeholder: "请选择您的所属机构",
        "show-all-levels": false,
        style: {
          "width": "100%"
        }
      }, null, 8, ["modelValue", "options", "props"]), _hoisted_17]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "mobile"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        placeholder: "请输入您的手机号码",
        modelValue: $data.registerForm.mobile,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.registerForm.mobile = $event),
        "auto-complete": "on",
        maxlength: "11",
        size: "default"
      }, {
        prefix: _withCtx(() => [_hoisted_18]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "code"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.registerForm.code,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.registerForm.code = $event),
        placeholder: "请输入您的手机验证码",
        autocomplete: "new-password",
        size: "default",
        maxlength: "4"
      }, {
        prefix: _withCtx(() => [_hoisted_19]),
        suffix: _withCtx(() => [_createElementVNode("div", _hoisted_20, [$data.codeShow ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "code-get",
          onClick: _cache[10] || (_cache[10] = $event => $options.getCode($data.registerForm.mobile, '2'))
        }, [_createVNode(_component_el_button, {
          type: "text"
        }, {
          default: _withCtx(() => [_createTextVNode("获取验证码")]),
          _: 1
        })])) : _createCommentVNode("", true), !$data.codeShow ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_el_button, {
          type: "text"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.count) + "秒后重新发送", 1)]),
          _: 1
        })])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "password"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.registerForm.password,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.registerForm.password = $event),
        type: "password",
        placeholder: "8~16位大小写字母+数字密码",
        autocomplete: "new-password",
        size: "default"
      }, {
        prefix: _withCtx(() => [_hoisted_22]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "agreeCheck"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_checkbox, {
        modelValue: $data.registerForm.agreeCheck,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.registerForm.agreeCheck = $event)
      }, null, 8, ["modelValue"]), _createTextVNode("   "), _hoisted_24])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_25, [_createVNode(_component_el_button, {
    class: "login-button",
    type: "primary",
    onClick: $options.confirmRegister
  }, {
    default: _withCtx(() => [_createTextVNode("立即注册")]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("span", {
    class: "link-unit",
    onClick: _cache[14] || (_cache[14] = $event => $data.showRegister = false)
  }, "立即登录")])])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
    "custom-class": "change-dialog",
    "close-on-click-modal": false,
    title: "重置密码",
    width: "400px",
    modelValue: $data.showResetDialog,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.showResetDialog = $event),
    "destroy-on-close": "",
    center: "",
    "before-close": $options.beforeClose
  }, {
    default: _withCtx(() => [_hoisted_28, _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_form, {
      ref: "resetForm",
      model: $data.resetForm,
      rules: $data.resetRules,
      "auto-complete": "on"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "phoneNumber"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          placeholder: "请输入您的手机号码",
          modelValue: $data.resetForm.phoneNumber,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.resetForm.phoneNumber = $event),
          name: "phoneNumber",
          "auto-complete": "on",
          maxlength: "11",
          size: "default"
        }, {
          prefix: _withCtx(() => [_hoisted_30]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "code"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.resetForm.code,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.resetForm.code = $event),
          placeholder: "请输入您的手机验证码",
          size: "default",
          maxlength: "4",
          autocomplete: "new-password"
        }, {
          prefix: _withCtx(() => [_hoisted_31]),
          suffix: _withCtx(() => [_createElementVNode("div", _hoisted_32, [$data.codeShow ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "code-get",
            onClick: _cache[16] || (_cache[16] = $event => $options.getCode($data.resetForm.phoneNumber, '0'))
          }, [_createVNode(_component_el_button, {
            type: "text"
          }, {
            default: _withCtx(() => [_createTextVNode("获取验证码")]),
            _: 1
          })])) : _createCommentVNode("", true), !$data.codeShow ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_el_button, {
            type: "text"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.count) + "秒后重新发送", 1)]),
            _: 1
          })])) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "password"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.resetForm.password,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.resetForm.password = $event),
          type: "password",
          placeholder: "8-16位大小写字母和数字的新密码",
          size: "default",
          autocomplete: "new-password"
        }, {
          prefix: _withCtx(() => [_hoisted_34]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "copyPassword"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.resetForm.copyPassword,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.resetForm.copyPassword = $event),
          type: "password",
          placeholder: "请再次输入新密码",
          size: "default"
        }, {
          prefix: _withCtx(() => [_hoisted_35]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]), _createElementVNode("span", _hoisted_36, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.confirmReset
    }, {
      default: _withCtx(() => [_createTextVNode("确认重置")]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["modelValue", "before-close"]), _createVNode(_component_el_dialog, {
    "close-on-click-modal": false,
    "custom-class": "bind-dialog",
    title: "绑定手机号",
    width: "400px",
    modelValue: $data.showBindPhoneDialog,
    "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.showBindPhoneDialog = $event),
    "destroy-on-close": "",
    center: "",
    "before-close": $options.beforeClose
  }, {
    default: _withCtx(() => [_hoisted_37, _createVNode(_component_el_form, {
      ref: "bindForm",
      model: $data.bindForm,
      rules: $data.bindRules,
      "auto-complete": "on"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "phoneNumber"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          placeholder: "请输入您的手机号码",
          modelValue: $data.bindForm.phoneNumber,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.bindForm.phoneNumber = $event),
          name: "phoneNumber",
          "auto-complete": "on",
          maxlength: "11",
          size: "default"
        }, {
          prefix: _withCtx(() => [_hoisted_38]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "code"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.bindForm.code,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.bindForm.code = $event),
          placeholder: "请输入您的手机验证码",
          size: "default",
          maxlength: "4"
        }, {
          prefix: _withCtx(() => [_hoisted_39]),
          suffix: _withCtx(() => [_createElementVNode("div", _hoisted_40, [$data.codeShow ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "code-get",
            onClick: _cache[22] || (_cache[22] = $event => $options.getCode($data.bindForm.phoneNumber, '1'))
          }, [_createVNode(_component_el_button, {
            type: "text"
          }, {
            default: _withCtx(() => [_createTextVNode("获取验证码")]),
            _: 1
          })])) : _createCommentVNode("", true), !$data.codeShow ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createVNode(_component_el_button, {
            type: "text"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.count) + "秒后重新发送", 1)]),
            _: 1
          })])) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"]), _createElementVNode("span", _hoisted_42, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.finishBind
    }, {
      default: _withCtx(() => [_createTextVNode("完成绑定")]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["modelValue", "before-close"]), _createVNode(_component_Captcha, {
    ref: "CaptchaEl",
    onSuccess: $options.captchaSuccess
  }, null, 8, ["onSuccess"])]);
}